import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "semantic-ui-react";
import styled from "styled-components";

function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname.split("/").slice(-1)[0] || "model-configs";

  const isActive = (path) => {
    if (path === "model-configs") {
      return currentPath === "model-configs" || currentPath === "create" || currentPath === "edit";
    }
    return currentPath.includes(path);
  };

  return (
    <NavWrapper>
      <Menu pointing secondary>
        <Menu.Item
          active={isActive("model-configs")}
          onClick={() => navigate("/app/llm-usage/model-configs")}
        >
          <i className="cog icon"></i>
          Model Configs
        </Menu.Item>
        <Menu.Item
          active={isActive("usage-logs")}
          onClick={() => navigate("/app/llm-usage/usage-logs")}
        >
          <i className="list icon"></i>
          Usage Logs
        </Menu.Item>
      </Menu>
    </NavWrapper>
  );
}

const NavWrapper = styled.div`
  margin-bottom: 20px;
  
  .ui.menu {
    border-bottom: 2px solid #e0e0e0;
    
    .item {
      font-weight: 500;
      
      &.active {
        border-color: #2185d0;
        color: #2185d0;
      }
      
      i.icon {
        margin-right: 8px;
      }
    }
  }
`;

export default Navigation;